module.exports = __webpack_public_path__ + "img/image_signing08@2x.17ee6dc3.png";